module.exports = __webpack_public_path__ + "static/media/rightdoublearrow.85185312.png";